import React from "react";
import { Download, ExternalLink, FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { getLegalDocumentItems, type LegalDocumentItem } from "../config/legalDocuments";

type LegalDocumentsListProps = {
  /** Compact rows for bottom sheet */
  compact?: boolean;
};

function openDoc(item: LegalDocumentItem) {
  window.open(item.href, "_blank", "noopener,noreferrer");
}

function downloadDoc(item: LegalDocumentItem) {
  const a = document.createElement("a");
  a.href = item.href;
  a.download = item.fileName;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function LegalDocumentsList({ compact = false }: LegalDocumentsListProps) {
  const { i18n } = useTranslation();
  const isEn = i18n.language.toLowerCase().startsWith("en");
  const items = getLegalDocumentItems(i18n.language);

  return (
    <div className={compact ? "space-y-2" : "space-y-2.5"}>
      {items.map((item) => {
        const title = isEn ? item.titleEn : item.titleRu;
        return (
          <div
            key={item.id}
            className="flex items-center gap-3 rounded-xl border border-gray-100 bg-white px-3 py-3"
          >
            <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center flex-shrink-0">
              <FileText size={18} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-[13px] text-gray-900 leading-snug">{title}</p>
            </div>
            <button
              type="button"
              onClick={() => openDoc(item)}
              className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-gray-50 text-gray-600 active:bg-gray-100"
              title={isEn ? "Open" : "Открыть"}
              aria-label={isEn ? "Open" : "Открыть"}
            >
              <ExternalLink size={16} />
            </button>
            <button
              type="button"
              onClick={() => downloadDoc(item)}
              className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-indigo-50 text-indigo-600 active:bg-indigo-100"
              title={isEn ? "Download" : "Скачать"}
              aria-label={isEn ? "Download" : "Скачать"}
            >
              <Download size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
